import { removeNonNumbers } from '@ott/transforms';
import type { Formatter } from '../types';
import { checkIsEmptyDate } from '../../checkIsEmptyDate';

export const parseMonth = (value: string): string => {
  if (checkIsEmptyDate(value)) {
    return '';
  }

  return removeNonNumbers(value).slice(0, 2);
};

export const formatMonth: Formatter = (value, prevValue, cursor, { isFocused }) => {
  if ((isFocused && value && value.length < 2) || !value) {
    return { value, cursor };
  }

  const parsedMonth = removeNonNumbers(value);
  if (parsedMonth.length === 1) {
    return { value: parsedMonth.padStart(2, '0'), cursor: 2 };
  }

  return { value: parsedMonth, cursor: parsedMonth.length };
};
